import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import '../../../style/SalesMarketing.css';
import * as React from "react";
import Box from "@mui/material/Box";
import {CheckCircleRounded} from '@mui/icons-material';
import {useNavigate} from "react-router-dom";

interface BusinessAgreementCreationModalProps {
    open: boolean,
    isUpdate: boolean,
    handleCloseCreationModal: Function,
}

const BusinessAgreementCreationModal = ({
                                open,
                                isUpdate,
                                handleCloseCreationModal
                            }: BusinessAgreementCreationModalProps) => {
    const {t} = useTranslation(['salesmarketing']);
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Dialog disableEscapeKeyDown fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <CheckCircleRounded color={"success"}/>
                    <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                        {isUpdate ? t('salesmarketing:businessAgreement.updateForm.modalTitleSuccess') : t('salesmarketing:businessAgreement.createForm.modalTitleSuccess')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <Grid item>
                        <Typography color={"primary"} variant={"body1"} style={{whiteSpace: "pre-line"}}>
                        {isUpdate ? t('salesmarketing:businessAgreement.updateForm.modalDescriptionSuccess') : t('salesmarketing:businessAgreement.createForm.modalDescriptionSuccess')}{t('')}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{backgroundColor: theme.palette.neutral.bright, padding: "15px"}}>
                <Button color={"accent"} onClick={() => {
                    handleCloseCreationModal();
                    navigate("/salesmarketing/businessagreementlist");
                }}>{t('salesmarketing:businessAgreement.buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default BusinessAgreementCreationModal;